export const transpileRatingsData = (data = {}) => ({
    fetchingRatingsConfig: false,
    savingColorConfiguration: false,
    siteUUID: data.siteUUID,
    ratingUnitUUID: data.ratingUnitUUID,
    configuration: transpileRatingsConfig(data.configuration)
});

export const transpileRatingsUnitCodeData = (data = {}) => ({
    headerCode: !data.headerCode ? '<script data-cfasync=\"false\" type=\"text/javascript\">(function (w, d, t, u) {\"Instiengage\"in w || (w.Instiengage = {products:[], load:function(p, uuid){Instiengage.products.push({p:p, uuid:uuid})}}); var s=d.createElement(t); s.src=u; s.async=!0; var r=d.getElementsByTagName(t)[0]; r.parentNode.insertBefore(s, r)})(window, document, \"script\", \"//s3.amazonaws.com/insticator-localhost-products/product-loader-script/loader.js\")</script>\n' : data.headerCode,
    ratingUnitCode: !data.ratingUnitCode ? '<div class=\"instiengage-ru-container\"><div class=\"instiengage-ru\" data-ru-uuid=\"524c301d-d606-45a7-b29c-6810020672cb\" data-ext-page-id=\"{extPageId}\" data-page-url=\"{articleUrl}\"></div><script data-cfasync=\"false\" type=\"text/javascript\">Instiengage.load(\"ru\", \"524c301d-d606-45a7-b29c-6810020672cb\")</script></div>\n' : data.ratingUnitCode,
    enablePageId: !data.enablePageId ? false : data.enablePageId
});

const transpileRatingsConfig = (data = {}) => ({
        uuid: data.uuid,
        ...transpileGeneral(data),
        colorConfiguration: transpileColorConfiguration(data.colorConfiguration),
        counterConfiguration: transpileCounterConfiguration(data.counterConfiguration)
});
export const transpileGeneral = (data = {}) => ({
    savingGeneral: false,
    title: {
        value: !!data.title ? data.title : '',
        valid: !!data.title ? true : null
    },
    firstRatingTitle: {
        value: !!data.firstRatingTitle ? data.firstRatingTitle : '',
        valid: !!data.firstRatingTitle ? true : null
    },
    thankYouMessage: {
        value: !!data.thankYouMessage ? data.thankYouMessage : '',
        valid: !!data.thankYouMessage ? true : null
    },
    zeroRatingLabel: {
        value: data.zeroRatingLabel ? data.zeroRatingLabel : '',
        valid: data.zeroRatingLabel ? true : null
    },
    oneRatingLabel: {
        value: data.oneRatingLabel ? data.oneRatingLabel : '',
        valid: data.oneRatingLabel ? true : null
    },
    multipleRatingsLabel: {
        value: data.multipleRatingsLabel ? data.multipleRatingsLabel : '',
        valid: data.multipleRatingsLabel ? true : null
    },
    enablePageId: !!data.enablePageId,
    fontConfiguration: transpileFontConfiguration(data.fontConfiguration),
})

const transpileFontConfiguration = (data = {}) => ({
    uuid: data.uuid,
    size: data.size ? data.size : "REGULAR",
    weight: data.weight ? data.weight : "REGULAR",
});

export const transpileColorConfiguration = (data = {}) => ({
    uuid: data.uuid,
    background: {
        value: data.background ? data.background : '#FFFFFF',
        valid: data.background ? true : null
    },
    primaryText: {
        value: data.primaryText ? data.primaryText : '#062B75',
        valid: data.primaryText ? true : null
    },
    brand: {
        value: data.brand ? data.brand : '#1494F4',
        valid: data.brand ? true : null
    },
    errorValidation: {
        value: data.errorValidation ? data.errorValidation : '#DF1D1D',
        valid: data.errorValidation ? true : null
    }
});

const transpileCounterConfiguration = (data = {}) => ({
    uuid: data.uuid,
    showHalfStars: !!data.showHalfStars,
    enabled: !!data.enabled
})
